import jsBridge from './utils/bridge.mjs';
import { API_GET_CLIENT_INFO, API_GET_COMMON_INFO, API_SHOW_LOADING, API_HIDE_LOADING, API_CONSOLE, VERSION_APP_UNSUPPORTED, API_GET_USER_CONSENT } from './utils/constant.mjs';
import { generateUUID } from './utils/helper.mjs';
import { Env, getLocalStorage, appendAppUA, App } from '@voghion/fe-util';
export var Gender;
(function (Gender) {
    Gender["Boy"] = "1";
    Gender["Girl"] = "2";
    Gender["Secret"] = "3";
})(Gender || (Gender = {}));
export var Channel;
(function (Channel) {
    Channel["h5"] = "1";
    Channel["android"] = "2";
    Channel["iOS"] = "3";
    Channel["pc"] = "4";
})(Channel || (Channel = {}));
const deviceCodeCacheKey = 'naDeviceCode';
function getDeviceCode(prefix) {
    const storage = getLocalStorage();
    let item = storage.getItem(deviceCodeCacheKey);
    if (!item) {
        item = `${prefix}-${generateUUID()}`;
        storage.setItem(deviceCodeCacheKey, item);
    }
    return item;
}
/**
 * 获取设备信息
 * @returns
 */
export function getClientInfo(params = {}) {
    return jsBridge
        .callPromise('', API_GET_CLIENT_INFO, params)
        .then((res) => {
        if (res.data && res.data.channel) {
            // android 返回的 channel 为数字
            res.data.channel += '';
        }
        if (res.error && res.error.isEnvInvalid) {
            const env = Env.getInstance();
            res.innerError = res.error;
            res.error = null;
            const { isDesktop } = env;
            const appSystem = isDesktop ? 'pc' : env.isIOS ? 'iOS' : 'android';
            res.data = {
                appName: 'Voghion',
                appSystem: appSystem,
                tradeName: appSystem,
                appSystemVersion: isDesktop
                    ? '10.0'
                    : env.isIOS
                        ? env.iOSVersion
                        : env.androidVersion,
                appVersion: '9.9.9',
                channel: isDesktop ? Channel.pc : Channel.h5,
                gender: Gender.Secret,
                country: 'DE',
                deviceCode: getDeviceCode(isDesktop ? 'pc' : 'h5'),
                interfaceVersion: '999',
                language: 'en',
                systemLanguage: 'en',
                netType: 'wifi',
                phoneType: '',
                userToken: '',
                currency: 'EUR'
            };
        }
        return res;
    });
}
/**
 * 获取公共信息
 * @returns userId 用户Id，未登录为空
 */
export function getCommonInfo(params = {}) {
    return jsBridge
        .callPromise('', API_GET_COMMON_INFO, params)
        .then((res) => {
        if (res.data && res.data.userId) {
            // ios 返回的 userId 为数字
            res.data.userId += '';
        }
        if (res.data && res.data.webAgent) {
            appendAppUA(App.Voghion, res.data.webAgent);
        }
        if (res.data) {
            const env = Env.getInstance();
            if (env.isIOS) {
                if (env.currentAppVersion === '2.2.3') {
                    // 兼容 ios 2.2.3 返回的 inAppTab 异常
                    res.data.inAppTab = window.screen.height - window.innerHeight >= 49;
                }
                else {
                    // 将 0/1 转为 boolean 值
                    res.data.inAppTab = !!res.data.inAppTab;
                }
            }
        }
        return res;
    });
}
/**
 * 显示原生loading
 * @returns
 */
export function showLoading(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.0.1',
        noResponse: true
    }, API_SHOW_LOADING, params);
}
/**
 * 隐藏原生loading
 * @returns
 */
export function hideLoading(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.0.1',
        noResponse: true
    }, API_HIDE_LOADING, params);
}
/**
 * 调用控制台输出
 * @returns
 */
export function console(params) {
    if (!params.api) {
        params.api = 'log';
    }
    return jsBridge.callPromise({
        minVersion: VERSION_APP_UNSUPPORTED,
        noResponse: true
    }, API_CONSOLE, params);
}
/**
 * 获取用户意见征求结果
 * @param params
 * @returns
 */
export function getUserConsent(params) {
    return jsBridge.callPromise({
        minVersion: '1.0.5'
    }, API_GET_USER_CONSENT, params);
}
